 

import { AppLayout } from "./app-layout";
import { OptResponse } from "../../login/otp/types";

interface Props {
    showFooter?: boolean;
    showOtpBanner?: boolean;
    otpDeliveryMode?: OptResponse;
    children: React.ReactNode;
    hideRegistartionLink?: boolean;
}

export function WebLayout({
    showFooter = true,
    children,
    showOtpBanner,
    otpDeliveryMode,
    hideRegistartionLink,
}: Props) {
    return (
        <AppLayout
            showFooter={showFooter}
            showOtpBanner={showOtpBanner}
            otpDeliveryMode={otpDeliveryMode}
            hideRegistartionLink={hideRegistartionLink}
        >
            {children}
        </AppLayout>
    );
}
